import { defineComponent as h, openBlock as a, createElementBlock as H, mergeProps as d, unref as o, renderSlot as Z, createElementVNode as e, createCommentVNode as M } from "vue";
import { useScalarIcon as p } from "../hooks/useScalarIcon.js";
const v = { key: 0 }, i = { key: 1 }, u = { key: 2 }, g = { key: 3 }, m = { key: 4 }, f = { key: 5 }, k = {
  name: "ScalarIconChartBar"
}, _ = /* @__PURE__ */ h({
  ...k,
  props: {
    label: {},
    weight: {}
  },
  setup(l) {
    const r = l, { bind: s, weight: n } = p(r);
    return (V, t) => (a(), H("svg", d({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(s)), [
      Z(V.$slots, "default"),
      o(n) === "bold" ? (a(), H("g", v, t[0] || (t[0] = [
        e("path", { d: "M224,196h-4V40a12,12,0,0,0-12-12H152a12,12,0,0,0-12,12V76H96A12,12,0,0,0,84,88v36H48a12,12,0,0,0-12,12v60H32a12,12,0,0,0,0,24H224a12,12,0,0,0,0-24ZM164,52h32V196H164Zm-56,48h32v96H108ZM60,148H84v48H60Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (a(), H("g", i, t[1] || (t[1] = [
        e("path", {
          d: "M208,40V208H152V40Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z" }, null, -1)
      ]))) : o(n) === "fill" ? (a(), H("g", u, t[2] || (t[2] = [
        e("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16h8V136a8,8,0,0,1,8-8H72a8,8,0,0,1,8,8v64H96V88a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8V200h16V40a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V200h8A8,8,0,0,1,232,208Z" }, null, -1)
      ]))) : o(n) === "light" ? (a(), H("g", g, t[3] || (t[3] = [
        e("path", { d: "M224,202H214V40a6,6,0,0,0-6-6H152a6,6,0,0,0-6,6V82H96a6,6,0,0,0-6,6v42H48a6,6,0,0,0-6,6v66H32a6,6,0,0,0,0,12H224a6,6,0,0,0,0-12ZM158,46h44V202H158ZM102,94h44V202H102ZM54,142H90v60H54Z" }, null, -1)
      ]))) : o(n) === "regular" ? (a(), H("g", m, t[4] || (t[4] = [
        e("path", { d: "M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z" }, null, -1)
      ]))) : o(n) === "thin" ? (a(), H("g", f, t[5] || (t[5] = [
        e("path", { d: "M224,204H212V40a4,4,0,0,0-4-4H152a4,4,0,0,0-4,4V84H96a4,4,0,0,0-4,4v44H48a4,4,0,0,0-4,4v68H32a4,4,0,0,0,0,8H224a4,4,0,0,0,0-8ZM156,44h48V204H156ZM100,92h48V204H100ZM52,140H92v64H52Z" }, null, -1)
      ]))) : M("", !0)
    ], 16));
  }
});
export {
  _ as default
};
